import { AfterViewInit, ChangeDetectorRef, Component, ContentChildren, ElementRef, Input, OnInit, QueryList, ViewChild } from '@angular/core';
import { IsActiveMatchOptions, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { BaseComponent } from '../../../core/components/base.component';

@Component({
  selector: 'app-nav-list-item',
  templateUrl: './nav-list-item.component.html',
  styleUrls: ['./nav-list-item.component.scss']
})
export class NavListItemComponent extends BaseComponent implements OnInit, AfterViewInit  {
  @Input() icon?: string;
  @Input() label!: string;
  @Input() _routerLink!: any;
  @Input() _queryParams?: any;
  @Input() collapsed!: boolean;
  @Input() isSubpage!: boolean;
  @ContentChildren(NavListItemComponent) content?: QueryList<NavListItemComponent>;
  level: number = 0;
  expanded: boolean = false;
  protected readonly isActiveMatchOptions = {
    matrixParams: 'exact',
    queryParams: 'ignored',
    fragment: 'exact',
    paths: 'subset'
  } as IsActiveMatchOptions;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly router: Router) {
    super();
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .unsubscribeOnDestroy(this)
      .subscribe(() => {
        // After navigation set manual expand to false.
        // Item might still be expanded due to active router link.
        this.expanded = false;
      });
  }

  ngAfterViewInit(): void {
    this.content?.forEach(item => {
      item.setLevel(this.level + 1);
    });
  }

  public setLevel(value: number): void {
    this.level = value;
    this.changeDetectorRef.detectChanges();
  }

  get hasSubItems(): boolean {
    return !!this.content?.length;
  }

  protected onClick(event: MouseEvent): void {
    if (this.hasSubItems) {
      event.stopPropagation();
      event.preventDefault();
      this.expanded = !this.expanded;
    }
  }
}
